export default __webpack_public_path__ + "static/media/google-play.feb2b8aa.jpg";